import { render, staticRenderFns } from "./HostedWaitingListFormOpeningHours.vue?vue&type=template&id=3c404535&scoped=true&"
import script from "./HostedWaitingListFormOpeningHours.vue?vue&type=script&lang=js&"
export * from "./HostedWaitingListFormOpeningHours.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c404535",
  null
  
)

export default component.exports